module.exports = {"user":{"no":"no.","name":"Name","empId":"Employee Id","isAdmin":"Is Admin","isNpiAdmin":"Is Npi","manage":"Manage Users","costCenterName":"Cost Center","viewList":"View Users","manageNpi":"Manage NPI admin","manageAdmin":"Manage Admin","edit":"Edit","submitNpiPermit":"Submit","cancel":"Cancel","backToList":"Back to List"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/user.json
// module id = 928
// module chunks = 108